import {ReportEditorActions} from 'common/report/contexts/report-editor-actions';
import {contextify, createRootContextHook} from 'common/util/react';

const context = contextify<ReportEditorActions>();

export const ReportEditorActionsProvider = context.Provider;
export const ReportEditorActionsConsumer = context.Consumer;
export const useReportEditorActions = createRootContextHook(`reportEditorActions`);
